import $ from "jquery";
import AnchorLinkUtils from "../utils/AnchorLinkUtils";
export default class AccordionHashedEntryController {
    constructor() {
        this.bindToLocalAnchorLinks();
        this.openHashedElementOnLoad();
    }
    bindToLocalAnchorLinks() {
        const localAnchorLinks = AnchorLinkUtils.findValidLinksOnThisPage();
        for (const anchor of localAnchorLinks) {
            anchor.addEventListener('click', (evt) => {
                const a = evt.target;
                const atag = a;
                const $targetElement = $(atag.hash);
                const $accordionLi = this.findAccordionItem($targetElement);
                if ($accordionLi) {
                    this.openAccordionItem($accordionLi);
                }
            });
        }
    }
    openHashedElementOnLoad() {
        const id = AccordionHashedEntryController.getIdFromUrlHash();
        if (!id) {
            return;
        }
        const e = document.getElementById(id);
        if (!e) {
            return;
        }
        const $item = this.findAccordionItem($(e));
        if ($item === null) {
            return;
        }
        this.openAccordionItem($item);
    }
    findAccordionItem($elem) {
        const $accordionLi = $elem.closest('.accordion-item');
        const isInAccordion = $accordionLi.length !== 0;
        return isInAccordion ? $accordionLi : null;
    }
    closeAccordionItem($itemLi) {
        const $content = $itemLi.find('> .accordion-collapse');
        const bsparentId = $content.data('bs-parent');
        const $items = $(".accordion-collapse[data-bs-parent='" + bsparentId + "']");
        $items.each(function () {
            const $item = $(this);
            $item.removeClass('show');
            const $button = $(".accordion-button[data-bs-target='#" + $item.attr('id') + "']");
            $button.addClass('collapsed');
        });
    }
    openAccordionItem($item) {
        this.closeAccordionItem($item);
        const $button = $item.find('> .accordion-header button');
        const $content = $item.find('> .accordion-collapse');
        $button.removeClass('collapsed');
        $content.addClass('show');
    }
    static getIdFromUrlHash() {
        const hash = window.location.hash;
        if (!hash.startsWith('#')) {
            return;
        }
        return hash.substring(1);
    }
    static mount() {
        new AccordionHashedEntryController();
    }
}
